import React, { Component } from 'react'

/**
 * Styles
 */
import './PublicEvents.css'

// Modules
import { getEvents } from '../../utils/eventsFunctions';

/**
 * Components
 */
import PublicEventsView from './PublicEventsView'

class publicEvents extends Component {

	constructor(props) {
		super(props)
		this.state = {
			arrayOfEvents: [],
			arrayOfEventsOriginal: [],

			loading: true,
		}
	}

	componentDidMount = () => {

		// /* Get all events */
		this.getEvents();
	}

	/* Get events */
	getEvents = async () => {
		let localArray = await getEvents();

		this.setState({
			arrayOfEvents: localArray,
			arrayOfEventsOriginal: localArray,
			loading: false
		})
	}

	/* Search event */
	searchEvent = (value) => {
		let localArray = []
		this.state.arrayOfEventsOriginal.forEach(event => {
			if (event.nome.toLowerCase().includes(value.toLowerCase())) {
				localArray.push(event)
			}
		})
		this.setState({
			arrayOfEvents: localArray
		})
	}

	render() {
		return (
			<PublicEventsView
				loading={this.state.loading}
				arrayOfEvents={this.state.arrayOfEvents}

				searchEvent={e => this.searchEvent(e)}
			/>
		)
	}

}

export default publicEvents